module.exports = __webpack_public_path__ + "img/67.6.CODm.e0414d2c.png";